module.exports = "/_next/static/images/3cdc418caa3e298826d5a4c93b2e68c2-cajita-xs.png.webp";